/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationMetricsAggregateTrendRequestForAi {
    getFixupPrototypeFunction() { return UtilizationMetricsAggregateTrendRequestForAi.fixupPrototype; }

    static newInstance(model: Partial<UtilizationMetricsAggregateTrendRequestForAi>): UtilizationMetricsAggregateTrendRequestForAi {
        let obj = Object.assign(new UtilizationMetricsAggregateTrendRequestForAi(), model);
        UtilizationMetricsAggregateTrendRequestForAi.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationMetricsAggregateTrendRequestForAi>): UtilizationMetricsAggregateTrendRequestForAi {
        if (!model) return null;
        return UtilizationMetricsAggregateTrendRequestForAi.newInstance(<UtilizationMetricsAggregateTrendRequestForAi> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationMetricsAggregateTrendRequestForAi) {
        if (!obj) return;

        models.UtilizationMetricsAggregateTrendRequestForAi.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationMetricsAggregateTrendRequestForAi): boolean {
        Object.setPrototypeOf(obj, UtilizationMetricsAggregateTrendRequestForAi.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
    }

    /**
     * AI platform service account to read the caller attribution shares of.
     */
    service_account_id: string;

    /**
     * AI platform resource (workspace / account) to read the caller attribution shares of.
     */
    resource_id: string;

    /**
     * specify the start date. The read is always served at daily grain.
     */
    start_date: Date;

    /**
     * specify the end date. Must be after the start date and within 90 days of it.
     */
    end_date: Date;

}
